import { Component } from 'src/utils';
import logo from './../../../images/logo-s.png';
import template from './auth-header.html';

@Component({
  controllerAs: 'header',
  template
})

export default class AuthHeaderContainer {
  constructor() {
    this.logo = logo;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/auth-header/auth-header.js